import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { notificationsRoutes } from './routes';
export class Notifications {
  constructor() {
    _defineProperty(this, "routes", notificationsRoutes);
  }
  async createNewNotification(data, options) {
    const resp = await requestService('auth').post(this.routes.notifications, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllNotifications(options) {
    const resp = await requestService('auth').get(this.routes.notifications, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSpecificNotifications(data, options) {
    const resp = await requestService('auth').get(this.routes.notificationsById(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putSpecificNotifications(data, options) {
    const id = data.id,
      rest = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('auth').put(this.routes.notificationsById(id), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteSpecificNotifications(data, options) {
    const resp = await requestService('auth').delete(this.routes.notificationsById(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async publishNotification(data, options) {
    const resp = await requestService('auth').post(this.routes.publish(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async unpublishNotification(data, options) {
    const resp = await requestService('auth').post(this.routes.unpublish(data.id), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPendingNotifications(options) {
    const resp = await requestService('auth').get(this.routes.pending, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async acknowledgementNotification(data, options) {
    const resp = await requestService('auth').post(this.routes.acknowledgement(data.notificationId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async viewNotification(data, options) {
    const resp = await requestService('auth').post(this.routes.view(data.notificationId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}